import React from "react";

export default function Layout({ children }) {
  return (
    <div className="bg-[#1e1e1e] h-screen w-screen overflow-scroll xs:px-8 sm:px-8 md:px-16 lg:px-4 xl:px-4 2xl:px-4">
      {children}
    </div>
  );
}
